import sendShappyPostMessageImport from './sendShappyPostMessage'
import getShappyInfoImport from './getShappyInfo'

export const sendShappyPostMessage = sendShappyPostMessageImport
export const getShappyInfoAPI = getShappyInfoImport



// WEBPACK FOOTER //
// ./src/store/modules/shappy/actions/index.js